module.exports = __webpack_public_path__ + "img/poi_icon_google_maps.50b8774.png";